import Switcher from './Switcher';

export default Switcher;



// WEBPACK FOOTER //
// ./src/containers/Switcher/index.js